
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Paper, Divider
} from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';

import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group, Label } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import {
    Chart as ChartJS, ArcElement, CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title, Tooltip, Legend
} from "chart.js";
import { Doughnut, Bar, Line } from "react-chartjs-2";
// import faker from 'faker';
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
}));

ChartJS.register(ArcElement, CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title, Tooltip, Legend);

export const options = {
    responsive: true,
    aspectRatio: 3,
    plugins: {
        legend: {
            position: 'bottom',
        },
        title: {
            display: true,
            // text: 'Chart.js Line Chart',
        },
    },
    scales: {
        y: {
            // title: {
            //   display: true,
            //   text: 'Value'
            // },
            min: 0,
            // max: 10,
            ticks: {
                // forces step size to be 50 units
                stepSize: 1
            }
        }
    }
};


// import { PieChart } from '@mui/x-charts/PieChart';



const API_HOST = CONFIG.modules['accounts'].host
const API_HOST_CRM = CONFIG.modules['crm'].host




export const LeadDashboard = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Leave Requests')
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [callsData, setCallsData] = useState(null)
    const [callsDayWise, setCallsDayWise] = useState(null)

    const getCallsData = () => {
        axios.get(API_HOST_CRM + `/get-dashboard-data?type=calls`).then((resp) => {
            if (resp.data && resp.data.success) {
                setCallsData(resp.data.data)
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const getCallsDayWiseData = () => {
        axios.get(API_HOST_CRM + `/get-dashboard-data?type=callsDayWise`).then((resp) => {
            if (resp.data && resp.data.success) {
                setCallsDayWise(resp.data.data)
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(() => {
        getCallsData()
        getCallsDayWiseData()
    }, [])


    return (

        <Box sx={{ mt: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column',
                    height: 150,
                    width: "32%", justifyContent: 'center', alignItems: 'center'
                }}>
                    {
                        callsData &&
                        <>
                            <Typography sx={{ color: '#EF5566', fontSize: '3em' }}>{callsData.totalCalls || 0}</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '1.2em' }}>Total Calls MTD</Typography>
                        </>
                    }

                </Paper>
                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column',
                    height: 150,
                    width: "32%", justifyContent: 'center', alignItems: 'center'
                }}>
                    {
                        callsData &&
                        <>
                            <Typography sx={{ color: '#EF5566', fontSize: '3em' }}>{callsData.totalCalldone || 0}</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '1.2em' }}>Productive Calls MTD</Typography>
                        </>
                    }


                </Paper>
                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column',
                    height: 150,
                    width: "32%", justifyContent: 'center', alignItems: 'center'
                }}>
                    {
                        callsData &&
                        <>
                            <Typography sx={{ color: '#EF5566', fontSize: '3em' }}>{callsData.avg || 0}</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '1.2em' }}>Daily Productive Average</Typography>
                        </>
                    }

                </Paper>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Paper elevation={3} sx={{
                    display: 'flex',
                    height: 150,
                    width: "100%", justifyContent: 'space-around', alignItems: 'center'
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        {
                            callsData &&
                            <>
                                <Typography sx={{ color: '#44536A', fontSize: '3em', }}>{callsData.unAssignedP || 0}%</Typography>
                                <Box sx={{ width: 200 }}>
                                    <BorderLinearProgress variant="determinate" value={parseInt(callsData.unAssignedP)} />
                                </Box>
                                <Typography sx={{ fontWeight: 500, fontSize: '1.2em', mt: 1 }}>UnAssigned Calls</Typography>
                            </>
                        }

                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

                        {
                            callsData &&
                            <>
                                <Typography sx={{ color: '#44536A ', fontSize: '3em' }}>{callsData.assignedP || 0}%</Typography>
                                <Box sx={{ width: 200 }}>
                                    <BorderLinearProgress variant="determinate" value={parseInt(callsData.assignedP)} />
                                </Box>
                                <Typography sx={{ fontWeight: 500, fontSize: '1.2em', mt: 1 }}>Assigned Calls</Typography>
                            </>
                        }

                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

                        {
                            callsData &&
                            <>
                                <Typography sx={{ color: '#44536A', fontSize: '3em' }}>{callsData.productiveP || 0}%</Typography>
                                <Box sx={{ width: 200 }}>
                                    <BorderLinearProgress variant="determinate" value={parseInt(callsData.productiveP)} />
                                </Box>
                                <Typography sx={{ fontWeight: 500, fontSize: '1.2em', mt: 1 }}>Productive Calls</Typography>
                            </>
                        }

                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

                        {
                            callsData &&
                            <>
                                <Typography sx={{ color: '#44536A', fontSize: '3em' }}>{callsData.badDataP || 0}%</Typography>
                                <Box sx={{ width: 200 }}>
                                    <BorderLinearProgress variant="determinate" value={parseInt(callsData.badDataP)} />
                                </Box>
                                <Typography sx={{ fontWeight: 500, fontSize: '1.2em', mt: 1 }}>Bad Data</Typography>
                            </>
                        }

                    </Box>


                </Paper>

            </Box>


            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column', padding: 0,
                    pb: 0,
                    "-webkit-justify-content": 'flex-start',
                    height: 370,
                    overflow: 'hidden',
                    width: "66%",
                }}>


                    <Box sx={{
                        display: 'flex', flexDirection: 'column', justifyContent: 'center',
                        height: 'inherit',
                        alignItems: 'center',
                        padding: 5
                    }}>
                        {/* <Box> */}
                        {
                            callsDayWise && Array.isArray(callsDayWise.arrayC) &&
                            <Line options={options} data={{
                                labels: callsDayWise.arrayC.map(e => dayjs(e.date, 'DD-MM-YYYY').format('ddd, DD-MMM-YY')),
                                datasets: [
                                    {
                                        label: 'Declined',
                                        data: callsDayWise.arrayC.map(e => e.countD),
                                        borderColor: '#60C7EE',
                                        backgroundColor: '#60C7EE',
                                    },
                                    {
                                        label: 'UnProductive',
                                        data: callsDayWise.arrayC.map(e => e.countU),
                                        borderColor: '#E9202A',
                                        backgroundColor: '#E9202A',
                                    },
                                    {
                                        label: 'Productive',
                                        data: callsDayWise.arrayC.map(e => e.countP),
                                        borderColor: '#169055',
                                        backgroundColor: '#169055',
                                    },
                                ],
                            }} />

                        }

                        {/* </Box> */}

                    </Box>



                </Paper>

                <Paper elevation={3} sx={{
                    display: 'flex', flexDirection: 'column', padding: 0,
                    pb: 0,
                    "-webkit-justify-content": 'flex-start',
                    height: 370,
                    overflow: 'hidden',
                    width: "32%",
                    padding: 2
                }}>


                    <Box sx={{
                        display: 'flex',
                        height: 'inherit',
                        alignItems: 'center'
                    }}>
                        <Box sx={{ width: '50%' }}>
                            <Typography sx={{ color: '#0563C2', fontSize: '3em', textAlign: 'center' }}>120</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '.7em', textAlign: 'center' }}>Total Employees</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '1.2em', textAlign: 'center' }}>Total Employees</Typography>
                        </Box>
                        <Box sx={{ width: '50%' }}>
                            <Typography sx={{ color: '#F08321', fontSize: '3em', textAlign: 'center' }}>120</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '.7em', textAlign: 'center' }}>Total Employees</Typography>

                            <Typography sx={{ fontWeight: 500, fontSize: '1.2em', textAlign: 'center' }}>Total Employees</Typography>
                        </Box>

                    </Box>
                    <Divider />
                    <Box sx={{
                        display: 'flex',
                        height: 'inherit',
                        alignItems: 'center'
                    }}>
                        <Box sx={{ width: '50%' }}>
                            <Typography sx={{ color: '#0563C2', fontSize: '3em', textAlign: 'center' }}>120</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '.7em', textAlign: 'center' }}>Total Employees</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '1.2em', textAlign: 'center' }}>Total Employees</Typography>
                        </Box>
                        <Box sx={{ width: '50%' }}>
                            <Typography sx={{ color: '#F08321', fontSize: '3em', textAlign: 'center' }}>120</Typography>
                            <Typography sx={{ fontWeight: 500, fontSize: '.7em', textAlign: 'center' }}>Total Employees</Typography>

                            <Typography sx={{ fontWeight: 500, fontSize: '1.2em', textAlign: 'center' }}>Total Employees</Typography>
                        </Box>
                    </Box>



                </Paper>



            </Box>


        </Box>

    )
}